<template>
  <div @click="goBack">
    <IconBase iconName="back"><IconBack /></IconBase>
  </div>
</template>

<script>
import IconBack from "./icons/IconBack";

export default {
  methods: {
    goBack() {
      if (window.history.length > 2) {
        this.$router.go(-1);

        return false;
      }

      this.$router.push({ name: "Home" });
    }
  },
  components: {
    IconBack
  }
};
</script>
